module.exports = __webpack_public_path__ + "media/icons/youtube-red@3x-ecf05ca5.svg";